import { SignInUrlBuilder } from './SignInUrlBuilder';

export class LoginUrls {
  private readonly prefix: string;

  public constructor(queryString?: string) {
    if (queryString && queryString.length > 0) {
      // Prepend a '?' if missing
      queryString = (queryString[0] === '?' ? '' : '?') + queryString;
    } else {
      queryString = '';
    }
    this.prefix = '/' + queryString + '#';
  }

  // The full url is prefixed by the query string and puts the path in the hash.
  private fullUrl(path: string): string {
    return this.prefix + path;
  }

  public signinUrl(queryParams: SignInUrlBuilder.QueryParams): string {
    const query = SignInUrlBuilder.buildQuery(queryParams);
    return this.fullUrl(LoginUrls.signinPart()) + (query ? `?${query}` : '');
  }

  public signinPath(): string {
    return LoginUrls.signinPart();
  }

  private static signinPart(): string {
    return '/signin';
  }

  public siteUrl(queryParams: SignInUrlBuilder.QueryParams): string {
    const query = SignInUrlBuilder.buildQuery(queryParams);
    return this.fullUrl(this.sitePath()) + (query ? `?${query}` : '');
  }

  public sitePath(): string {
    return LoginUrls.sitePart();
  }

  private static sitePart(): string {
    return '/site';
  }

  private static errorPart(): string {
    return '/error';
  }

  public loginErrorPath(): string {
    return LoginUrls.errorPart();
  }

  public signinAuthErorrUrl(errorCode: string, redirectPath: string = ''): string {
    return this.fullUrl(this.signinAuthErorrPath(errorCode, redirectPath));
  }

  public signinAuthErorrPath(errorCode: string, redirectPath: string = ''): string {
    return LoginUrls.errorPart() + LoginUrls.signinPart() + `/${errorCode}`
      + (redirectPath ? `?${LoginUrls.redirectPathQueryKey()}=${encodeURIComponent(redirectPath)}` : '');
  }

  public static redirectPathQueryKey(): string {
    return 'redirectPath';
  }

  public signinErorrCodeFromSiteSwitchUrl(errorCode: string): string {
    return this.fullUrl(this.signinErorrCodeFromSiteSwitchPath(errorCode));
  }

  public signinErorrCodeFromSiteSwitchPath(errorCode: string): string {
    return this.signinErorrCodePath(errorCode) + `?${LoginUrls.fromSiteSwitchQueryKey()}=yes`;
  }

  public static fromSiteSwitchQueryKey(): string {
    return 'fromSiteSwitch';
  }

  public signinErorrCodeUrl(errorCode: string): string {
    return this.fullUrl(this.signinErorrCodePath(errorCode));
  }

  public signinErorrCodePath(errorCode: string): string {
    return LoginUrls.errorPart() + `/${errorCode}`;
  }

  public signedOutUrl(): string {
    return this.fullUrl(this.signedOutPath());
  }

  public signedOutPath(): string {
    return '/signedOut';
  }

  public siteSamlSignedOutUrl(): string {
    return this.fullUrl(this.siteSamlSignedOutPath());
  }

  public siteSamlSignedOutPath(): string {
    return '/siteSamlSignedOut';
  }

  public requestPasswordResetUrl(): string {
    return this.fullUrl(this.requestPasswordResetPath());
  }

  public requestPasswordResetPath(): string {
    return '/requestPasswordReset';
  }

  public passwordResetWithTokenUrl(token: string): string {
    return this.fullUrl(this.passwordResetWithTokenPath(token));
  }

  public passwordResetWithTokenPath(token: string): string {
    return LoginUrls.resetPasswordPart() + '/' + token;
  }

  public passwordResetWithUsernameUrl(username: string): string {
    return this.fullUrl(this.passwordResetWithUsernamePath(username));
  }

  public passwordResetWithUsernamePath(username: string): string {
    return LoginUrls.resetPasswordPart() + '/?' + LoginUrls.usernameQueryKey() + '=' + username;
  }

  public static usernameQueryKey(): string {
    return 'username';
  }

  private static resetPasswordPart(): string {
    return '/resetPassword';
  }

  public passwordResetUserNameBasePath(): string {
    return LoginUrls.resetPasswordPart() + '/';
  }
}
